<!-- Geometry matches Skeleton Screens prototypes: desktop/tablet `skelShipFrom`, mobile 390pt Ship From body. -->
<div class="ship-from-ship-to-skeleton" aria-hidden="true" data-testid="ship-from-ship-to-skeleton">
  <!-- Desktop / tablet: both address sections with multi-column grids. -->
  <div class="ship-from-ship-to-skeleton__wide">
    @for (section of sections; track section.titleWidth) {
      <div class="ship-from-ship-to-skeleton__section">
        <div class="ship-from-ship-to-skeleton__section-header">
          <div class="ship-from-ship-to-skeleton__titles">
            <app-skeleton-block [width]="section.titleWidth" height="30" />
            <app-skeleton-block width="168" height="11" tone="secondary" />
          </div>
          <app-skeleton-block width="108" height="38" radius="card" />
        </div>

        <div class="ship-from-ship-to-skeleton__check-row">
          <app-skeleton-block width="17" height="17" radius="stub" [animated]="false" />
          <app-skeleton-block
            class="ship-from-ship-to-skeleton__check-label"
            [width]="section.primaryCheckLabelWidth"
            height="12"
            tone="secondary"
          />
        </div>

        <div
          class="ship-from-ship-to-skeleton__wide-rows ship-from-ship-to-skeleton__wide-rows--desktop"
        >
          @for (row of fieldRowsDesktop; track row.kind === 'line' ? row.width : row.rowClass) {
            @if (row.kind === 'line') {
              <app-skeleton-block [width]="row.width" height="12" tone="secondary" />
            } @else {
              <div class="ship-from-ship-to-skeleton__row {{ row.rowClass }}">
                @for (column of columnPlaceholders(row.columnCount); track column) {
                  <app-skeleton-block height="52" radius="card" />
                }
              </div>
            }
          }
        </div>

        <div
          class="ship-from-ship-to-skeleton__wide-rows ship-from-ship-to-skeleton__wide-rows--tablet"
        >
          @for (row of fieldRowsTablet; track row.kind === 'line' ? row.width : row.rowClass) {
            @if (row.kind === 'line') {
              <app-skeleton-block [width]="row.width" height="12" tone="secondary" />
            } @else {
              <div class="ship-from-ship-to-skeleton__row {{ row.rowClass }}">
                @for (column of columnPlaceholders(row.columnCount); track column) {
                  <app-skeleton-block
                    height="54"
                    radius="card"
                    [tone]="column === 1 && row.rowClass.includes('phone') ? 'emphasis' : 'base'"
                  />
                }
              </div>
            }
          }
        </div>

        @for (checkLabelWidth of section.trailingCheckLabelWidths; track checkLabelWidth) {
          <div class="ship-from-ship-to-skeleton__check-row">
            <app-skeleton-block width="17" height="17" radius="stub" [animated]="false" />
            <app-skeleton-block
              class="ship-from-ship-to-skeleton__check-label"
              [width]="checkLabelWidth"
              height="12"
              tone="secondary"
            />
          </div>
        }

        @if (section.showFooter) {
          <div class="ship-from-ship-to-skeleton__divider"></div>
          <div class="ship-from-ship-to-skeleton__actions">
            <app-skeleton-block width="188" height="52" radius="card" />
          </div>
        }
      </div>
    }
  </div>

  <!-- Mobile 390pt: Ship From only — stacked fields matching mobile prototype body. -->
  <div class="ship-from-ship-to-skeleton__mobile">
    <app-skeleton-block width="250" height="30" />
    <app-skeleton-block width="168" height="12" tone="secondary" />
    <app-skeleton-block width="104" height="44" radius="card" />

    <div class="ship-from-ship-to-skeleton__check-row ship-from-ship-to-skeleton__check-row--wrap">
      <app-skeleton-block width="18" height="18" radius="stub" [animated]="false" />
      <div class="ship-from-ship-to-skeleton__check-copy">
        <app-skeleton-block width="100%" height="12" tone="secondary" />
        <app-skeleton-block width="42%" height="12" tone="secondary" />
      </div>
    </div>

    @for (groupCount of mobileFieldGroups; track $index) {
      <div class="ship-from-ship-to-skeleton__stack">
        @for (field of columnPlaceholders(groupCount); track field) {
          <app-skeleton-block height="58" radius="card" />
        }
      </div>

      @if ($index === 0) {
        <div class="ship-from-ship-to-skeleton__check-row">
          <app-skeleton-block width="16" height="16" radius="stub" [animated]="false" />
          <app-skeleton-block width="206" height="13" tone="secondary" />
        </div>
      }
    }

    <div class="ship-from-ship-to-skeleton__phone-row">
      <app-skeleton-block width="92" height="58" radius="card" tone="emphasis" />
      <div class="ship-from-ship-to-skeleton__phone-grow">
        <app-skeleton-block height="58" radius="card" />
      </div>
    </div>
    <app-skeleton-block height="58" radius="card" />
    <app-skeleton-block height="58" radius="card" />
  </div>
</div>
